<template>
  <!--srcviewscompanydetailsBusinessActivitiesSupplyChainvuehtmlStart-->

  <div v-loading="RiskLoding">
    <div id="g2ede8" class="operations-content margin-bottom10">
      <h2 id="gf7b16" class="operations-head-content detail_title_20">
        <div>
          <h2 class="operations-head">{{ $t("SearchTrade.TradeMap") }}</h2>
        </div>

        <div class="perations-content-left">
          <span
            :class="
              activeIEports == '1'
                ? 'perations-button perations-button-active'
                : 'perations-button'
            "
            @click="ceckIEports('1')"
            >{{ $t("SearchTrade.Imports") }}</span
          >
          <span
            @click="ceckIEports('2')"
            :class="
              activeIEports == '2'
                ? 'perations-button perations-button-active'
                : 'perations-button'
            "
            >{{ $t("SearchTrade.Exports") }}</span
          >
        </div>
      </h2>
      <div class="Product_Supply_select flex_center_bettwen margin-bottom10">
        <div class="">
          <el-select
            v-model="Importyear"
            placeholder="Please Select"
            class="supply_select"
            @change="getCountrygetProductMapCountry(2)"
          >
            <el-option
              v-for="item in Yearoptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
        <el-button
          style="background: #009ea7 !important"
          class="btn_export"
          @click="getCountrygetProductMapCountry(0)"
        >
          {{ $t("SearchTrade.Reset") }}</el-button
        >
      </div>
      <div class="flex_between_box" style="width: 100%">
        <div class="operations-box">
          <div class="graph_controls">
            <button
              @click="fullScreen"
              v-if="!isFullScreen"
              class="btn_control"
            >
              <i class="iconfont icon-quanping" />
            </button>
            <button @click="exitFullScreen" v-else class="btn_control">
              <i class="iconfont icon-suohui" />
            </button>
            <button @click="zoomLarge" class="btn_control">
              <i class="iconfont icon-fangda" />
            </button>
            <button @click="zoomSmall" class="btn_control">
              <i class="iconfont icon-suoxiao" />
            </button>
            <button @click="resetZoom" class="btn_control">
              <i class="iconfont icon-huanyuan" />
            </button>
          </div>

          <div
            ref="SupplyChainEchart"
            class="trade_map_chart map114514"
            :class="isFullScreen ? 'fullscream_trade_map_chart' : ''"
          ></div>
        </div>
        <div class="Trade-Map-right">
          <div class="flex_center_start_box">
            <span
              class="font16 font1A2332 Maptext font_bold"
              v-if="activeIEports == 1"
              >{{ $t("SearchTrade.Origin") }}:
            </span>
            <span
              class="font16 font1A2332 Maptext font_bold"
              v-if="activeIEports == 2"
              >{{ $t("SearchTrade.Destination") }}:
            </span>
            <el-select
              v-model="CountryCode"
              placeholder="Please Select"
              @change="getCountrygetProductMapCountry(2)"
              class="map_select margin-left10"
            >
              <el-option
                v-for="(item, index) in CountryCodeoptions"
                :key="item.countryName"
                :label="item.countryName"
                :value="item.countryCode"
              >
                <span
                  style="display: block; max-width: 100%; line-height: auto"
                  class="Country_name"
                >
                  {{ index + 1 }} {{ item.countryName }}</span
                >
              </el-option>
            </el-select>
          </div>
          <div class="flex_center_start_box margin-top10">
            <span
              class="font16 font1A2332 Maptext font_bold"
              v-if="activeIEports == 1"
              >{{ $t("SearchTrade.Destination") }}:
            </span>
            <span
              class="font16 font1A2332 Maptext font_bold"
              v-if="activeIEports == 2"
              >{{ $t("SearchTrade.Origin") }}:
            </span>
            <el-select
              v-model="destinationCountryCode"
              placeholder="Please Select"
              @change="getData()"
              class="map_select margin-left10"
            >
              <el-option
                v-for="(item, index) in destinationCountryList"
                :key="item.countryName"
                :label="item.countryName"
                :value="item.countryCode"
              >
                <span
                  style="display: block; max-width: 100%; line-height: auto"
                  class="Country_name"
                >
                  {{ index + 1 }} {{ item.countryName }}</span
                >
              </el-option>
            </el-select>
          </div>
          <p class="font16 font1A2332 margin-top20 font_bold margin-bottom20">
            {{ $t("SearchTrade.TotalTransactions") }} {{ this.Importyear }}:
            <span style="font-family: Arial Arial">{{
              sumTransaction | FormatNum
            }}</span>
          </p>
          <el-table
            ref="treeTable"
            style="max-height: 673px; overflow-y: auto; width: 100%"
            class="table_height_50 table_contentHeight_40 computer_right_cont_box TotaltvTable"
            :data="tradeDetailList"
            :row-class-name="tableRowClassName"
            border
          >
            <!-- 空数据状态的插槽 -->
            <template slot="empty"> {{ $t("SearchTrade.NoData") }} </template>

            <el-table-column
              :label="$t('SearchTrade.Date')"
              prop="date"
              align="left"
              show-overflow-tooltip
              :resizable="false"
            />

            <el-table-column
              :label="$t('SearchTrade.Transactions')"
              prop="sumTradeNum"
              align="left"
              show-overflow-tooltip
              :resizable="false"
            >
              <template slot-scope="scope">
                <span class="font16 font1A2332 Maptext">{{
                  scope.row.sumTradeNum | FormatNum
                }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <CompanyBar></CompanyBar>
    <TradeTrends></TradeTrends>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>

<script>
import {
  getProductCountryMapDropDown,
  getProductMapCountry,
  getProductCountryMap,
  getProductTradeMap,
} from "@/api/companyApi.js";
import ReLogin from "../../../../components/ReLogin.vue";
import CompanyBar from "./CompanyBar.vue";
import TradeTrends from "./indextree.vue";
export default {
  name: "",
  // props: {},
  components: {
    ReLogin,
    CompanyBar,
    TradeTrends,
  },
  data() {
    return {
      // myChart: null,   echartsBox
      isFullScreen: false,
      scaleLevel: 1,
      minScale: 0.5,
      maxScale: 2.5,

      data: {
        links: [],
        nodes: [],
      },

      Importyear: "",
      Yearoptions: [],
      datePicker: [" 2025-01", "2025-12"],

      activeIEports: "1",
      importTrendListEcharts: [],
      allData: null,
      sourceData: [],
      CountryCodeoptions: [],
      sumTransaction: "",
      destinationCountryList: [],
      CountryCode: "",
      destinationCountryCode: "",
      reLoginVis: false,
      tradeDetailList: [],
      RiskLoding: false,
    };
  },
  mounted() {
    this.getProductRankingDropDownOdLsit();
    this.$emit("UpdatamarkTotalList", true);
    this.$store.dispatch("app/setTools", {
      name: "select",
      key: "isActive",
      value: false,
    });
    window.addEventListener("resize", this.resizeFn);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },

  methods: {
    // ... 其他方法

    // 缩放
    zoomLarge() {
      this.scaleLevel = Math.min(this.scaleLevel + 0.2, this.maxScale);
      this.resizeFn();
    },
    zoomSmall() {
      this.scaleLevel = Math.max(this.scaleLevel - 0.2, this.minScale);
      this.resizeFn();
    },
    resetZoom() {
      this.scaleLevel = 1;
      this.resizeFn();
    },
    // 全屏
    fullScreen() {
      const elem = document.getElementsByClassName("operations-box")[0];

      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
      this.isFullScreen = true;
      this.resizeFn();
    },
    // 退出全屏
    exitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
      this.isFullScreen = false;
      this.resizeFn();
    },

    // 计算并设置最大值行的样式
    tableRowClassName({ row, rowIndex }) {
      // 检查数据是否存在且不为空
      if (!this.tradeDetailList || this.tradeDetailList.length === 0) {
        return "";
      }

      // 过滤掉值为 '-' 或其他非数字值的数据，只处理有效数值
      const validValues = this.tradeDetailList
        .filter(
          (item) =>
            item.sumTradeNum !== "-" &&
            item.sumTradeNum != null &&
            !isNaN(Number(item.sumTradeNum)),
        )
        .map((item) => Number(item.sumTradeNum));

      // 如果没有有效数值，则不进行高亮
      if (validValues.length === 0) {
        return "";
      }

      // 找到有效数值中的最大值
      const maxSumTradeNum = Math.max(...validValues);

      // 检查当前行是否为有效数值且等于最大值
      if (
        row.sumTradeNum !== "-" &&
        row.sumTradeNum != null &&
        !isNaN(Number(row.sumTradeNum)) &&
        Number(row.sumTradeNum) === maxSumTradeNum
      ) {
        return "highlight-row";
      }

      return "";
    },

    // ... 其他方法
    resizeFn() {
      this.suppleEchart();
    },
    getCountrygetProductMapCountry(value) {
      this.RiskLoding = true;
      getProductTradeMap({
        tradeCode: this.$route.query.id3a,
        tradeType: this.activeIEports,
        tradeYear: this.Importyear,
        originCountryCode: value == 0 ? "" : this.CountryCode,
        destinationCountryCode: "",
      }).then((res) => {
        if (res.code == 200) {
          this.allData = res.data.allData;
          this.suppleEchart();
          this.CountryCodeoptions = res.data.originCountryList;
          this.destinationCountryList = res.data.destinationCountryList;
          if (value == 1 || value == 0) {
            this.CountryCode = this.CountryCodeoptions[0].countryCode;
          }

          this.destinationCountryCode =
            this.destinationCountryList[0].countryCode;

          this.sourceData = res.data.sourceData;
          this.sumTransaction = res.data.sumTransaction;
          this.tradeDetailList = res.data.tradeDetailList;
          this.RiskLoding = false;
        } else {
          this.allData = [];
          this.suppleEchart();

          this.RiskLoding = false;
          this.CountryCodeoptions = [];
          this.destinationCountryList = [];
        }
      });
    },

    ceckIEports(row) {
      this.activeIEports = row;
      this.CountryCode = "";
      this.destinationCountryCode = "";
      this.getProductRankingDropDownOdLsit();
    },
    getProductRankingDropDownOdLsit() {
      getProductCountryMapDropDown({
        hsCode: this.$route.query.id3a,
        type: this.activeIEports,
      }).then((res) => {
        if (res.code == 200) {
          this.Yearoptions = res.data;
          this.Importyear = res.data[0];
          this.getCountrygetProductMapCountry(1);
        }
      });
    },
    getData() {
      getProductTradeMap({
        tradeCode: this.$route.query.id3a,
        tradeType: this.activeIEports,
        tradeYear: this.Importyear,
        originCountryCode: this.CountryCode,
        destinationCountryCode: this.destinationCountryCode,
      }).then((res) => {
        if (res.code == 200) {
          this.tradeDetailList = res.data.tradeDetailList;
        }
      });
    },
    suppleEchart() {
      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);
      // 飞线图
      var allData = this.allData;
      // console.log(allData);
      // console.log(666);
      // console.log(this.$echarts.getMap('world').geoJSON.features.map(f => f.properties.name))
      var countryRegions = [];
      for (let i = 0; i < allData.moveLines.length; i++) {
        var a = {
          name: allData.moveLines[i].fromName,
          itemStyle: {
            areaColor: "#FFA000",
          },
        };
        var b = {
          name: allData.moveLines[i].toName,
          itemStyle: {
            areaColor: "#00AFA7",
          },
        };
        countryRegions.push(a);
        countryRegions.push(b);
      }
      let that = this;

      const option = {
        backgroundColor: "#EEEEEE",
        tooltip: {
          trigger: "item",
        },
        geo: {
          map: "world",

          regions: countryRegions,

          zoom: this.scaleLevel, // 初始缩放级别
          roam: "move", // 禁止拖动缩放
          label: { show: false },
          itemStyle: {
            normal: {
              borderColor: "#3EC3E3", // 边界颜色
              borderWidth: 0,
              areaColor: "#3F6D6F", // 地图区域颜色
              shadowColor: "#3F6D6F", // 阴影颜色
              shadowOffsetX: 0,
              shadowOffsetY: 0,
            },
            emphasis: {
              areaColor: "#11E291", // 高亮颜色
              borderWidth: 0.2,
              show: false,
            },
          },
          tooltip: {
            trigger: "item",
            extraCssText:
              "width: 324px; white-space: normal; word-break: break-all;color:#1a2332;box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.12);padding: 20px;",
            formatter: function (params) {
              // 只在点和飞线上显示 tooltip
              if (
                params.seriesType === "scatter" ||
                params.seriesType === "lines"
              ) {
                if (params.seriesType === "scatter") {
                  return `${params.marker}${params.data.name}<br/> ${that.$t(
                    "SearchTrade.Origin",
                  )} :${params.data.value[2]}`;
                } else if (params.seriesType === "lines") {
                  return ` ${that.$t("SearchTrade.Product")} : ${
                    params.data.product
                  } <br/> ${that.$t("SearchTrade.Origin")} : ${
                    params.data.fromName
                  }<br/> ${that.$t("SearchTrade.Destination")} : ${
                    params.data.toName
                  }<br/> ${that.$t("SearchTrade.Transactions")} : ${
                    params.data.transactions
                  }`;
                }
              }
              // 其他情况返回空字符串，不显示 tooltip
              return "";
            },
          },
        },
        series: [
          // 基础地图层
          // 动态涟漪点目标点
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            zlevel: 3,
            rippleEffect: {
              //涟漪特效
              period: 15, //动画时间，值越小速度越快
              brushType: "stroke", //波纹绘制方式 stroke, fill
              scale: 3, //波纹圆环最大限制，值越大波纹越大
            },
            label: {
              normal: {
                show: true,
                position: "right", //显示位置
                offset: [5, 0], //偏移设置
                formatter: function (params) {
                  return params?.value[2];
                },
                textStyle: {
                  color: that.activeIEports == 1 ? "#1A2332" : "#F79E05", // 青蓝色
                },
              },
            },
            emphasis: {
              show: true,
              scale: !0,
              label: {
                show: true,
                backgroundColor: "#000",
                padding: 2,
                borderRadius: 2,
                color: "#fff",
              },
            },
            symbol: "circle",
            symbolSize: 8,
            itemStyle: {
              normal: {
                show: false,
                color: that.activeIEports == 1 ? "#17B5AE" : "#F79E05", // 青蓝色
              },
            },
            data: allData.citys,
          },
          // 连接线
          {
            type: "lines",
            coordinateSystem: "geo",
            zlevel: 2,
            large: true,
            lineStyle: {
              color: that.activeIEports == 1 ? "#17B5AE" : "#F79E05", // 青蓝色
              width: 1,
              curveness: 0.3, // 线条曲度
            },
            label: {
              normal: {
                show: false,
                position: "middle",
                formatter: "{b}",
              },
            },
            data: allData.moveLines,
          },
        ],
      };
      this.echartsBox.setOption(option);
      this.$nextTick(() => {
        this.echartsBox.resize();
      });

      this.echartsBox.on("georoam", function (params) {
        // 获取当前的 center
        let option = that.echartsBox.getOption();
        let center = option.geo[0].center; // [lng, lat]
        let zoom = option.geo[0].zoom;

        // 设定经纬度边界
        let minLng = -180,
          maxLng = 180;
        let minLat = -90,
          maxLat = 90;

        let newLng = Math.max(minLng, Math.min(center[0], maxLng));
        let newLat = Math.max(minLat, Math.min(center[1], maxLat));

        // 如果超出边界，重置
        if (newLng !== center[0] || newLat !== center[1]) {
          that.echartsBox.setOption({
            geo: [
              {
                center: [newLng, newLat],
                zoom: zoom,
              },
            ],
          });
        }
      });
    },
  },
  computed: {},
};
</script>
<style scoped>
.operations-head {
  color: #009ea7;
}

.operations-box {
  width: calc(100% - 480px);
  position: relative;
}
.operations-content {
  padding: 30px 40px;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

.table-content-color {
  color: #009ea7;
}

.perations-button-active {
  background: #ffffff !important;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 21px;
  color: #009ea7 !important;
  cursor: pointer;
}

/deep/ .el-range-editor.el-input__inner {
  padding: 0px !important;
}

.Maptext {
  display: inline-block;
  width: 110px;
}

.Trade-Map-right {
  padding-left: 40px;
  width: 480px;
  position: relative;
}
.TotaltvTable {
  width: 440px;
  bottom: 0px;
}
.SupplyChainEchart {
  width: 100%;
  height: 850px;
}
.Product_Supply_select {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 5px;
}

/deep/ .highlight-row td {
  background-color: #eafafa !important;
  color: #009ea7 !important;
}

/deep/ .highlight-row td .font16,
/deep/ .highlight-row td .cell {
  color: #009ea7 !important;
}

/deep/ .el-table__row:not(.highlight-row):hover td {
  background-color: #eafafa !important;
}
.supply_select {
  width: 390px;
}
.map_select {
  flex: 1;
}
.map_select >>> .el-input__inner {
  font-size: 18px;
}
.font26 {
  font-size: 26px !important;
}
.btn_export {
  border-radius: 5px;
  font-size: 16px;
  min-width: 120px;
  padding: 10px 20px;
}

.fullscream_trade_map_chart {
  height: 100vh !important;
}

.graph_controls {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 8;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 40px;
  padding: 20px 0;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.btn_control {
  width: 40px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  background-color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 24px;
  font-weight: 500;
  transition: all 0.3s;
}

.btn_control i {
  font-size: 20px;
}
.btn_control:hover {
  background-color: #f0f0f0;
  border-color: #999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.btn_control:active {
  background-color: #e0e0e0;
}
@media (max-width: 1920px) {
  .operations-content {
    padding: 22px 30px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  }
  .Product_Supply_select {
    padding: 15px;
  }
  .operations-box {
    width: calc(100% - 360px);
  }
  .trade_map_chart {
    height: 770px;
  }
  .Trade-Map-right {
    padding-left: 30px;
    width: 360px;
  }
  .TotaltvTable {
    width: 330px;
  }
  .supply_select {
    width: 292px;
  }
  .map_select >>> .el-input__inner {
    font-size: 16px;
  }
  .font26 {
    font-size: 20px !important;
  }
  .btn_export {
    font-size: 14px;
    min-width: 90px;
    padding: 9px 20px;
  }

  .btn_control {
    height: 20px;
    line-height: 16px;
    font-size: 20px;
  }
}
@media screen and (max-width: 1439px) {
  .operations-content {
    padding: 20px 26px;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
  }
  .Product_Supply_select {
    padding: 13px;
  }
  .operations-box {
    width: calc(100% - 320px);
  }
  .trade_map_chart {
    height: 640px;
  }
  .Trade-Map-right {
    padding-left: 26px;
    width: 320px;
  }
  .TotaltvTable {
    width: 294px;
  }
  .supply_select {
    width: 262px;
  }
  .map_select >>> .el-input__inner {
    font-size: 14px;
  }
  .font26 {
    font-size: 18px !important;
  }
}
</style>
<style>
.computer_right_cont_box.el-table .el-table__cell {
  padding: 10px 0 !important;
}
</style>
